import { render } from "./Drafts.vue?vue&type=template&id=7c43ffd8&scoped=true"
import script from "./Drafts.vue?vue&type=script&lang=js"
export * from "./Drafts.vue?vue&type=script&lang=js"

import "./Drafts.vue?vue&type=style&index=0&id=7c43ffd8&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c43ffd8"]])

export default __exports__